import ApiERP from '@/core/conectores/ApiERP';
import { IFiltroGenerico } from '@/core/models/BuscaAvancada/IFiltroGenerico';
import { IItemConsultaRapida } from '@/core/models/Consulta/IItemConsultaRapida';
import { IListaPaginada } from '@/core/models/Consulta/IListaPaginada';
import { IParametrosConsulta } from '@/core/models/Consulta/IParametrosConsulta';
import { IParametrosConsultaRapida } from '@/core/models/Consulta/IParametrosConsultaRapida';
import { IPropriedadeConsulta } from '@/core/models/Consulta/PropriedadeConsulta';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IOrdenacaoRegistro } from '@/core/models/IOrdenacaoRegistro';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
import { IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { IServicoBase } from '@/core/models/IServicoBase';
import { IOrdemProducao } from '@/models/Entidades/PCP/IOrdemProducao';
import { ETipoEtiqueta } from '@/models/Enumeradores/ETipoEtiqueta';
import { EStatusProducao } from '@/models/Enumeradores/PCP/EStatusProducao';
import { IParametrosConsultaOP } from '@/models/ParametrosRequisicao/PCP/IParametrosConsultaOP';

class ServicoOrdemProducao implements IServicoBase<IOrdemProducao> {
  endPoint = 'pcp-ordem-producao';

  apiERP = new ApiERP();

  requisicaoSistema(): void {
    this.apiERP = new ApiERP(true);
  }

  public async obterPropriedadesConsulta(): Promise<IPropriedadeConsulta[]> {
    const listaPropriedades = await this.apiERP.obterPropriedadesConsulta(this.endPoint);
    return listaPropriedades;
  }

  public async buscaAvancada(parametrosConsulta: IParametrosConsulta, filtros?: Array<IFiltroGenerico>): Promise<IListaPaginada> {
    return this.apiERP.buscaAvancada(this.endPoint, parametrosConsulta, filtros);
  }

  public async relatorioPadrao(tipoArquivo: ETipoArquivo, parametrosConsulta: IParametrosConsulta, filtros?: IFiltroGenerico[], codigosSelecionados?: Array<number>): Promise<IRetornoRelatorio> {
    return this.apiERP.relatorioPadrao(this.endPoint, tipoArquivo, parametrosConsulta, filtros, codigosSelecionados);
  }

  public obterIdentificacaoRegistroGradeCRUD(objeto: any): string {
    return objeto.descricao;
  }

  public async consultaRapida(parametrosConsultaRapida: IParametrosConsultaRapida): Promise<IItemConsultaRapida[]> {
    const result: any = await this.apiERP.post(`${this.endPoint}/consulta-rapida`, parametrosConsultaRapida);
    return result.data;
  }

  public async incluir(objeto: IOrdemProducao): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.post(`${this.endPoint}`, objeto);
    return result.data;
  }

  public async alterar(objeto: IOrdemProducao): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.put(`${this.endPoint}/${objeto.codigo}`, objeto);
    return result.data;
  }

  public async obter(codigo: number, empresa: number): Promise<IOrdemProducao> {
    const result: any = await this.apiERP.get(`${this.endPoint}/${codigo}/empresa/${empresa}`);
    return result.data;
  }

  public async excluir(codigo: number): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.delete(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public async criarPorEngenharia(parametros: IParametrosConsultaOP): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.post(`${this.endPoint}/criar-por-engenharia`, parametros);
    return result.data;
  }

  public async concluir(ordemProducao: IOrdemProducao): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.post(`${this.endPoint}/concluir`, ordemProducao);
    return result.data;
  }

  public async imprimirOrdemProducao(codigo: number): Promise<IRetornoRelatorio> {
    const result: any = await this.apiERP.get(`${this.endPoint}/${codigo}/impressao/`);
    return result.data;
  }

  public async imprimirEtiqueta(codigo: number, empresa: number, tipo: ETipoEtiqueta): Promise<IRetornoRelatorio> {
    const result: any = await this.apiERP.get(`${this.endPoint}/etiqueta/${codigo}/empresa/${empresa}/tipo/${tipo}`);
    return result.data;
  }

  public async imprimirEtiquetaPadrao(codigoRegistro: number, empresa: number): Promise<IRetornoRelatorio> {
    const result: any = await this.apiERP.get(`${this.endPoint}/etiqueta/${codigoRegistro}/empresa/${empresa}`);
    return result.data;
  }

  public async imprimirMapa(codigo: number): Promise<IRetornoRelatorio> {
    const result: any = await this.apiERP.get(`${this.endPoint}/${codigo}/impressao-mapa/`);
    return result.data;
  }

  public async iniciar(ordemProducao: IOrdemProducao): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.post(`${this.endPoint}/iniciar`, ordemProducao);
    return result.data;
  }

  public async TransferirLote(ordemProducao: IOrdemProducao): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.post(`${this.endPoint}/transferir-lote`, ordemProducao);
    return result.data;
  }

  public async AtualizarControlesOPConcluida(ordemProducao: IOrdemProducao): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.post(`${this.endPoint}/atualizar-controles-op-concluida`, ordemProducao);
    return result.data;
  }

  public async AtualizarObservacaoDeOPConcluida(ordemProducao: IOrdemProducao): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.post(`${this.endPoint}/atualizar-observacao-op-concluida`, ordemProducao);
    return result.data;
  }

  public async atualizarOrdenacao(empresa: number, ordenacaoRegistros: IOrdenacaoRegistro[]): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.put(`${this.endPoint}/ordenacao/empresa/${empresa}`, ordenacaoRegistros);
    return result.data;
  }

  public async atualizarEtapa(op: number, etapa: number): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.put(`${this.endPoint}/${op}/etapas/${etapa}`);
    return result.data;
  }

  public async ReverterMovimentoOrdemProducao(ordemProducao: IOrdemProducao, statusAlvo: EStatusProducao): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.post(`${this.endPoint}/reverter-movimento/${statusAlvo}`, ordemProducao);
    return result.data;
  }
}

export default ServicoOrdemProducao;
